 export function jwtOptionsFactory(provider:any) {
    return {
        tokenGetter: () => localStorage.getItem('token'),
        whitelistedDomains:['localhost','localhost/api','localhost:44377','localhost:65018','lasc.azurewebsites.net','lascselfhelpapicicd.azurewebsites.net'],
        blacklistedRoutes:['localhost:44377/api/auth','lasc.azurewebsites.net/api/auth','lascselfhelpapicicd.azurewebsites.net/api/auth']
      }
}